import { Loader } from 'shared/components/loader'
import { CheckIcon } from '@systemeio/ui'

export const getStateStatusIcon = (isLoading: boolean, isSuccess?: boolean) => {
  if (isLoading) {
    return <Loader small />
  }
  if (isSuccess) {
    return <CheckIcon className="stroke-green h-5 w-5" />
  }
}
